var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReorderingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.791016 6.66536C0.791016 6.20513 1.14546 5.83203 1.58268 5.83203H17.416C17.8532 5.83203 18.2077 6.20513 18.2077 6.66536C18.2077 7.1256 17.8532 7.4987 17.416 7.4987H1.58268C1.14546 7.4987 0.791016 7.1256 0.791016 6.66536ZM0.791016 13.332C0.791016 12.8718 1.14546 12.4987 1.58268 12.4987H17.416C17.8532 12.4987 18.2077 12.8718 18.2077 13.332C18.2077 13.7923 17.8532 14.1654 17.416 14.1654H1.58268C1.14546 14.1654 0.791016 13.7923 0.791016 13.332Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderingIcon);
export default __webpack_public_path__ + "static/media/reordering-icon.cbb7ae98ac8c84a59edab1a64d6f2fa9.svg";
export { ForwardRef as ReactComponent };